// LIST
export const FETCH_TERMINALS = "app/TERMINAL/FETCH_TERMINALS";
export const FETCH_TERMINALS_SUCCESS = "app/TERMINAL/FETCH_TERMINALS_SUCCESS";
export const FETCH_TERMINALS_FAILURE = "app/TERMINAL/FETCH_TERMINALS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/TERMINAL/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/TERMINAL/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/TERMINAL/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_TERMINAL = "app/TERMINAL/ADD_TERMINAL";
export const ADD_TERMINAL_SUCCESS = "app/TERMINAL/ADD_TERMINAL_SUCCESS";
export const ADD_TERMINAL_FAILURE = "app/TERMINAL/ADD_TERMINAL_FAILURE";

// EDIT
export const EDIT_TERMINAL = "app/TERMINAL/EDIT_TERMINAL";
export const EDIT_TERMINAL_SUCCESS = "app/TERMINAL/EDIT_TERMINAL_SUCCESS";
export const EDIT_TERMINAL_FAILURE = "app/TERMINAL/EDIT_TERMINAL_FAILURE";

// DELETE
export const DELETE_TERMINAL = "app/TERMINAL/DELETE_TERMINAL";
export const DELETE_TERMINAL_SUCCESS = "app/TERMINAL/DELETE_TERMINAL_SUCCESS";
export const DELETE_TERMINAL_FAILURE = "app/TERMINAL/DELETE_TERMINAL_FAILURE";
